import React from "react"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Block from "@bappweb/block"
import Page from "@smpu-web/globalmodules/page"

const ErrorPage = () => {

  return (
    <Page>
      <Block type="section" className="error-page">
        <Image path={"./img/juzdan/logo.png"}/>
        <Block>
            <Element type="h3">
                {"ÜZGÜNÜZ"}
            </Element>
            <Element type="p">
              {"Uygulamamız cihazınız tarafından desteklenmemektedir."}
            </Element>
        </Block>
      </Block>
    </Page>
  )
}

export default ErrorPage